import { getMobileFontSizeClassName } from '../build-global-css';
import { toMobileFontSize } from '../font-utils/to-mobile-font-size';
import { getStyleProp } from './css-property-utils';
export var injectMobileFontSizeClass = function (el, props) {
    var fontSize = getStyleProp(el, 'font-size', props.css);
    if (fontSize) {
        var mobileFontSize = toMobileFontSize(fontSize);
        el.addClass(getMobileFontSizeClassName(mobileFontSize));
    }
};
//# sourceMappingURL=inject-mobile-font-size-class.js.map